<div class="container news" [ngClass]="{ 'row-2': rows === 2,'autoHeight':autoHeight}">
    <div class="header-news d-flex align-items-center">
        <div class="logo-icon"></div>
        <h3 class="d-inline">
            <span *ngIf="!blockTitleAsLink">{{ title }}</span>
            <a routerLink="{{ link }}" *ngIf="blockTitleAsLink && !linkParams">{{ title }}</a>
            <a [routerLink]="[link]" [queryParams]="linkParams" *ngIf="blockTitleAsLink && linkParams">{{ title }}</a>
        </h3>
        <div *ngIf="!!category?.subcate" class="d-flex align-items-center ml-4">
            <a [routerLink]="[subcate.routerLink]" [queryParams]="subcate.params"
                class="sub-category" *ngFor="let subcate of category.subcate">
                <span>{{ subcate.title }}</span>
            </a>
        </div>
    </div>
    <div class="content">
        <div *ngIf="showOutDated" class="d-flex align-items-start mb-2 v-n-place" style="min-height: 160px;"
            [ngClass]="{'pureBg': recommendedVideos.length > 0}">
            <div *ngFor="let recommendedVideo of recommendedVideos.slice(0, 8); let last=last;let i = index" class="v-c video-teaser news-item"
            [video]="recommendedVideo" [display]="display"
                [ngClass]="{'visible-lg':i==6,'visible-xl':i>=6}">

            </div>
        </div>

        <div class="rec-slider position-relative d-flex align-items-start mb-2 v-n-place" [ngClass]="{'pureBg': recommendedVideos.length > 0}">
          <div class="nav-shadow-cover last" *ngIf="currentIndex > 0"
            [ngClass]="{'hidden': hideLeft}">
          </div>
          <div class="nav-btn last" *ngIf="currentIndex > 0"
            [ngClass]="{'hidden': hideLeft}">
            <i class="iconfont iconjiantou_liebiaoxiangzuo" (click)="navLast()"></i>
          </div>
          <div class="rec-track d-flex" #track>
            <div class="new-svideo-container" style="margin-right: 5px;" [display]="7"
              *ngFor="let item of recommendedVideos" [video]="item"
              (currentMediaKey)="currentMediaKeyHandler($event)" (playerShowed)="previewHandler($event)">
            </div>
          </div>
          <div class="nav-shadow-cover next" *ngIf="currentIndex < (recommendedVideos.length - newColumn)"
            [ngClass]="{'hidden': hideRight}">
          </div>
          <div class="nav-btn next" *ngIf="currentIndex < (recommendedVideos.length - newColumn)" 
            [ngClass]="{'hidden': hideRight}">
            <i class="iconfont iconjiantou_liebiaoxiangyou" (click)="navNext()"></i>
          </div>
        </div>
    </div>
</div>